import { createTitleBarGlobalSearchStore } from '@frontend/shell-utils';

export const useTitleBarGlobalSearchStore = createTitleBarGlobalSearchStore();
